/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as NoAccessRouteImport } from './routes/no-access'
import { Route as UploadRouteImport } from './routes/upload'
import { Route as ExperimentsIndexRouteImport } from './routes/experiments.index'
import { Route as ExperimentsIdRouteImport } from './routes/experiments.$id'
import { Route as GuidesIdRouteImport } from './routes/guides.$id'
import { Route as InstrumentsIndexRouteImport } from './routes/instruments.index'
import { Route as InstrumentsIdRouteImport } from './routes/instruments.$id'
import { Route as MachinesKeyRouteImport } from './routes/machines.$key'
import { Route as ProceduresIndexRouteImport } from './routes/procedures.index'
import { Route as ProceduresIdRouteImport } from './routes/procedures.$id'
import { Route as RunsIdRouteImport } from './routes/runs.$id'
import { Route as SignInSplatRouteImport } from './routes/sign-in.$'
import { Route as GuidesIdReviewRouteImport } from './routes/guides.$id_.review'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const NoAccessRoute = NoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => rootRouteImport,
} as any)
const UploadRoute = UploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperimentsIndexRoute = ExperimentsIndexRouteImport.update({
  id: '/experiments/',
  path: '/experiments/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperimentsIdRoute = ExperimentsIdRouteImport.update({
  id: '/experiments/$id',
  path: '/experiments/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const GuidesIdRoute = GuidesIdRouteImport.update({
  id: '/guides/$id',
  path: '/guides/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const InstrumentsIndexRoute = InstrumentsIndexRouteImport.update({
  id: '/instruments/',
  path: '/instruments/',
  getParentRoute: () => rootRouteImport,
} as any)
const InstrumentsIdRoute = InstrumentsIdRouteImport.update({
  id: '/instruments/$id',
  path: '/instruments/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const MachinesKeyRoute = MachinesKeyRouteImport.update({
  id: '/machines/$key',
  path: '/machines/$key',
  getParentRoute: () => rootRouteImport,
} as any)
const ProceduresIndexRoute = ProceduresIndexRouteImport.update({
  id: '/procedures/',
  path: '/procedures/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProceduresIdRoute = ProceduresIdRouteImport.update({
  id: '/procedures/$id',
  path: '/procedures/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const RunsIdRoute = RunsIdRouteImport.update({
  id: '/runs/$id',
  path: '/runs/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInSplatRoute = SignInSplatRouteImport.update({
  id: '/sign-in/$',
  path: '/sign-in/$',
  getParentRoute: () => rootRouteImport,
} as any)
const GuidesIdReviewRoute = GuidesIdReviewRouteImport.update({
  id: '/guides/$id_/review',
  path: '/guides/$id/review',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/no-access': typeof NoAccessRoute
  '/upload': typeof UploadRoute
  '/experiments/$id': typeof ExperimentsIdRoute
  '/guides/$id': typeof GuidesIdRoute
  '/instruments/$id': typeof InstrumentsIdRoute
  '/machines/$key': typeof MachinesKeyRoute
  '/procedures/$id': typeof ProceduresIdRoute
  '/runs/$id': typeof RunsIdRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/experiments/': typeof ExperimentsIndexRoute
  '/instruments/': typeof InstrumentsIndexRoute
  '/procedures/': typeof ProceduresIndexRoute
  '/guides/$id/review': typeof GuidesIdReviewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/no-access': typeof NoAccessRoute
  '/upload': typeof UploadRoute
  '/experiments/$id': typeof ExperimentsIdRoute
  '/guides/$id': typeof GuidesIdRoute
  '/instruments/$id': typeof InstrumentsIdRoute
  '/machines/$key': typeof MachinesKeyRoute
  '/procedures/$id': typeof ProceduresIdRoute
  '/runs/$id': typeof RunsIdRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/experiments': typeof ExperimentsIndexRoute
  '/instruments': typeof InstrumentsIndexRoute
  '/procedures': typeof ProceduresIndexRoute
  '/guides/$id/review': typeof GuidesIdReviewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/no-access': typeof NoAccessRoute
  '/upload': typeof UploadRoute
  '/experiments/$id': typeof ExperimentsIdRoute
  '/guides/$id': typeof GuidesIdRoute
  '/instruments/$id': typeof InstrumentsIdRoute
  '/machines/$key': typeof MachinesKeyRoute
  '/procedures/$id': typeof ProceduresIdRoute
  '/runs/$id': typeof RunsIdRoute
  '/sign-in/$': typeof SignInSplatRoute
  '/experiments/': typeof ExperimentsIndexRoute
  '/instruments/': typeof InstrumentsIndexRoute
  '/procedures/': typeof ProceduresIndexRoute
  '/guides/$id_/review': typeof GuidesIdReviewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/no-access'
    | '/upload'
    | '/experiments/$id'
    | '/guides/$id'
    | '/instruments/$id'
    | '/machines/$key'
    | '/procedures/$id'
    | '/runs/$id'
    | '/sign-in/$'
    | '/experiments/'
    | '/instruments/'
    | '/procedures/'
    | '/guides/$id/review'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/no-access'
    | '/upload'
    | '/experiments/$id'
    | '/guides/$id'
    | '/instruments/$id'
    | '/machines/$key'
    | '/procedures/$id'
    | '/runs/$id'
    | '/sign-in/$'
    | '/experiments'
    | '/instruments'
    | '/procedures'
    | '/guides/$id/review'
  id:
    | '__root__'
    | '/'
    | '/no-access'
    | '/upload'
    | '/experiments/$id'
    | '/guides/$id'
    | '/instruments/$id'
    | '/machines/$key'
    | '/procedures/$id'
    | '/runs/$id'
    | '/sign-in/$'
    | '/experiments/'
    | '/instruments/'
    | '/procedures/'
    | '/guides/$id_/review'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  NoAccessRoute: typeof NoAccessRoute
  UploadRoute: typeof UploadRoute
  ExperimentsIdRoute: typeof ExperimentsIdRoute
  GuidesIdRoute: typeof GuidesIdRoute
  InstrumentsIdRoute: typeof InstrumentsIdRoute
  MachinesKeyRoute: typeof MachinesKeyRoute
  ProceduresIdRoute: typeof ProceduresIdRoute
  RunsIdRoute: typeof RunsIdRoute
  SignInSplatRoute: typeof SignInSplatRoute
  ExperimentsIndexRoute: typeof ExperimentsIndexRoute
  InstrumentsIndexRoute: typeof InstrumentsIndexRoute
  ProceduresIndexRoute: typeof ProceduresIndexRoute
  GuidesIdReviewRoute: typeof GuidesIdReviewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/no-access': {
      id: '/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof NoAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upload': {
      id: '/upload'
      path: '/upload'
      fullPath: '/upload'
      preLoaderRoute: typeof UploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiments/': {
      id: '/experiments/'
      path: '/experiments'
      fullPath: '/experiments/'
      preLoaderRoute: typeof ExperimentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiments/$id': {
      id: '/experiments/$id'
      path: '/experiments/$id'
      fullPath: '/experiments/$id'
      preLoaderRoute: typeof ExperimentsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guides/$id': {
      id: '/guides/$id'
      path: '/guides/$id'
      fullPath: '/guides/$id'
      preLoaderRoute: typeof GuidesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instruments/': {
      id: '/instruments/'
      path: '/instruments'
      fullPath: '/instruments/'
      preLoaderRoute: typeof InstrumentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instruments/$id': {
      id: '/instruments/$id'
      path: '/instruments/$id'
      fullPath: '/instruments/$id'
      preLoaderRoute: typeof InstrumentsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/machines/$key': {
      id: '/machines/$key'
      path: '/machines/$key'
      fullPath: '/machines/$key'
      preLoaderRoute: typeof MachinesKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/procedures/': {
      id: '/procedures/'
      path: '/procedures'
      fullPath: '/procedures/'
      preLoaderRoute: typeof ProceduresIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/procedures/$id': {
      id: '/procedures/$id'
      path: '/procedures/$id'
      fullPath: '/procedures/$id'
      preLoaderRoute: typeof ProceduresIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/runs/$id': {
      id: '/runs/$id'
      path: '/runs/$id'
      fullPath: '/runs/$id'
      preLoaderRoute: typeof RunsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in/$': {
      id: '/sign-in/$'
      path: '/sign-in/$'
      fullPath: '/sign-in/$'
      preLoaderRoute: typeof SignInSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guides/$id_/review': {
      id: '/guides/$id_/review'
      path: '/guides/$id/review'
      fullPath: '/guides/$id/review'
      preLoaderRoute: typeof GuidesIdReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  NoAccessRoute: NoAccessRoute,
  UploadRoute: UploadRoute,
  ExperimentsIdRoute: ExperimentsIdRoute,
  GuidesIdRoute: GuidesIdRoute,
  InstrumentsIdRoute: InstrumentsIdRoute,
  MachinesKeyRoute: MachinesKeyRoute,
  ProceduresIdRoute: ProceduresIdRoute,
  RunsIdRoute: RunsIdRoute,
  SignInSplatRoute: SignInSplatRoute,
  ExperimentsIndexRoute: ExperimentsIndexRoute,
  InstrumentsIndexRoute: InstrumentsIndexRoute,
  ProceduresIndexRoute: ProceduresIndexRoute,
  GuidesIdReviewRoute: GuidesIdReviewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
